export const LOAD_FEED_LIST_REQUEST = 'news/LOAD_FEED_LIST_REQUEST';
export const LOAD_FEED_LIST_SUCCESS = 'news/LOAD_FEED_LIST_SUCCESS';
export const LOAD_FEED_LIST_FAILURE = 'news/LOAD_FEED_LIST_FAILURE';
